/*
 * @Description  :
 * @Version      : 1.0.0
 * @Author       : Luoye
 * @Date         : 2022-08-03 15:25:49
 * @LastEditors  : Luoye
 * @FilePath     : /namibox_client_web/src/views/app-guide.ReactPage/store/reducer/index.tsx
 * Copyright (C) 2022 rose. All rights reserved.
 */
import { GLOBEL_CHANGE_LOADING } from '../actionTypes';

interface ActionTypes {
  type: string;
  payload: object;
}

export interface LoadingState {
  loading: boolean;
  loadText: string;
}
export type StateType = LoadingState;

const initState = {
  loading: false,
  loadText: '正在加载',
};

function reducer(state: LoadingState = initState, action: ActionTypes) {
  switch (action.type) {
    case GLOBEL_CHANGE_LOADING:
      console.log(123, action);
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}

export default reducer;
